<template>
  <v-list-item class="pa-0 v-list-item-wrapper">
    <div class="d-flex align-center justify-space-between wrapper">
      <span
        v-if="showLabel"
        class="switcher-label"
      >
        {{
          isMasterView
            ? $t('navigation.master.labels.switch-master')
            : $t('navigation.master.labels.switch-normal')
        }}
      </span>

      <v-switch
        :model-value="isMasterView"
        @update:modelValue="switchView()"
        color="primary"
        flat
        class="switcher"
      />
    </div>
    <ChildCompaniesList
      class="child-companies-list"
      v-if="isMasterView"
      :is-master-dashboard="isMasterDashboard"
      :is-master-view="isMasterView"
    />
  </v-list-item>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import ChildCompaniesList from '@/modules/navigation/ChildCompaniesList.vue'

defineProps<{
  showLabel: Boolean
}>()
const route = useRoute()
const isMasterView = computed(() => {
  return route.path.startsWith('/master')
})
const emit = defineEmits<{
  (e: 'switch-view'): void
}>()
const switchView = () => {
  emit('switch-view')
}
const isMasterDashboard = computed(() => route.name === 'master-dashboard')
</script>
<style scoped>
.v-list-item-wrapper {
  border-top: 1px solid #0000001f;
  border-bottom: 1px solid #0000001f;
}
.wrapper {
  height: 42px;
  padding: 0 16px;
}
.child-companies-list {
  padding: 0 16px;
}
.switcher-label {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.switcher {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding-top: 22px;
  color: #6e6e6e;
}
</style>
